module.exports = __webpack_public_path__ + "img/X.397f8710.svg";